import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { isEmptyDocument } from '@atlaskit/editor-common/utils';
import { fg } from '@atlaskit/platform-feature-flags';

import type { AIPlugin } from '../../aiPluginType';
import { aiExperienceDecorationPluginKey } from '../decoration/decoration-plugin-key';

export const createPlaceholderControllerPlugin = (options: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
}): SafePlugin => {
	const { api } = options;

	return new SafePlugin({
		view(_editorView) {
			let previousIsRunning = false;
			return {
				update(view, _prevState) {
					if (!api?.placeholder || !api?.core) {
						return;
					}

					const state = view.state;
					const aiDecorationState = aiExperienceDecorationPluginKey.getState(state);
					const currentIsRunning = aiDecorationState?.isRunning ?? false;

					if (currentIsRunning !== previousIsRunning) {
						previousIsRunning = currentIsRunning;

						if (fg('platform_editor_ai_aifc_patch_beta_2')) {
							api.core.actions.execute(
								api.placeholder.commands.setPlaceholderHidden(currentIsRunning),
							);
						} else {
							if (isEmptyDocument(state.doc)) {
								api.core.actions.execute(
									api.placeholder.commands.setPlaceholderHidden(currentIsRunning),
								);
							}
						}
					}
				},
			};
		},
	});
};
